import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, Image, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColorContainerImageAndContentConverter extends CmsConverterService<ColorContainerImageAndContentData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_alt_text?.value
    const title = formData.st_title_text?.value
    const lazyLoad = formData.st_lazy_load_image
    return {
      image: CmsConverterService.mapImage(formData.st_image, lazyLoad, altText, title),
      disableDetailsView: formData.st_disable_image_details_view?.value ?? false,
      label: formData.st_label ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      enableCaption: formData.st_enable_caption?.value ?? false,
      caption: formData.st_caption ?? defaultTextInput,
      captionColor: formData.st_caption_color?.value?.identifier ?? '',
      overlayCaption: formData.st_caption_overlay ?? defaultTextInput,
      overlayDescription: formData.st_description_overlay ?? defaultTextInput,
      alignImage: formData.st_align_image?.value?.identifier ?? '',
      text: formData.st_text ?? defaultTextInput,
      textCentered: formData.st_centered_text?.value ?? false,
      spacing: {
        top: formData.st_spacing_bottom?.value?.identifier ?? '',
        bottom: formData.st_spacing_top?.value?.identifier ?? ''
      },
      callToActionButton: formData.st_call_to_actions ?? defaultFSCatalog,
      relatedItems: formData.st_related_items ?? defaultFSCatalog
    }
  }
}

export const COLOR_CONTAINER_IMAGE_AND_CONTENT_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent,
  ColorContainerImageAndContentData>>('ColorContainerImageAndContentConverter')

export interface ColorContainerImageAndContentData extends ConvertedComponentData {
  alignImage: string;
  image: Image;
  label: TextInput;
  headline: TextInput;
  captionColor: string;
  caption: TextInput;
  enableCaption: boolean;
  overlayCaption: TextInput;
  overlayDescription: TextInput;
  textCentered: boolean;
  text: TextInput;
  spacing: Spacing;
  callToActionButton: FsCatalog;
  relatedItems: FsCatalog;
}
